export default "__VITE_ASSET__9aaf2099__"